import { useEffect } from "react";
import { checkMessageOrigin } from "../utils/general";

const toSatList = (params) => {
    let sats = [];

    if(!params.satnos.startsWith("$")) {
        sats.push(...params.satnos.split(","));
    }
    else {
        if(!params.satno.startsWith("$")) {
            sats.push(params.satno);
        }
        if(!params.satno2.startsWith("$")) {
            sats.push(params.satno2);
        }
    }

    sats = sats.map((s) => {
        return s.trim().replace("{", "").replace("}", "");
    }).filter((s) => s !== "None");

    return sats.length > 0 ? sats : null;
}

const useSatnoPersister = (setLastSelectedSats) => {
    useEffect(() => {
        const handleMessage = (e) => {
            let msg = e.data;

            if(msg?.type === "spacefana-satno-change") {
                if(!checkMessageOrigin(e)) return;
                setLastSelectedSats(toSatList(msg.params));
            }
        };

        // on mount
        window.addEventListener('message', handleMessage);

        return () => {
            // on unmount
            window.removeEventListener('message', handleMessage); 
        }
    }, [setLastSelectedSats]);
};

export default useSatnoPersister;